import { ISubjectValue, ISubjectFieldValue } from "@/consts/interfaces";

const SUBJECTS: Array<ISubjectValue> = [
    {name: "国語", value: "kokugo"},
    {name: "社会", value: "shakai"},
    {name: "数学", value: "sugaku"},
    {name: "理科", value: "rika"},
    {name: "英語", value: "eigo"}
]

const SUBJECTFIELDS: Array<ISubjectFieldValue> = [
    {name: "国語", value: "kokugo", root: "kokugo"},
    {name: "地理", value: "chiri", root: "shakai"},
    {name: "歴史", value: "rekishi", root: "shakai"},
    {name: "公民", value: "komin", root: "shakai"},
    {name: "数学", value: "sugaku", root: "sugaku"},
    {name: "理科", value: "rika", root: "rika"},
    {name: "英語", value: "eigo", root: "eigo"}
]

const SUBJECT_ALL: ISubjectValue = {name: "総合", value: "all"}

const SUBJECT_MAP: { [id: string] : string } = {
    "国語": "kokugo",
    "社会": "shakai",
    "数学": "sugaku",
    "理科": "rika",
    "英語": "eigo",
}

const SUBJECTFIELD_MAP: { [id: string] : string } = {
    "国語": "kokugo",
    "地理": "chiri",
    "歴史": "rekishi",
    "公民": "komin",
    "数学": "sugaku",
    "理科": "rika",
    "英語": "eigo",
}

const SUBJECTFIELD_SORT_MAP: {[id: string] : number} = {
    "地理": 0,
    "歴史": 1,
    "公民": 2,
}

const SOCIETY_SUBJECT_FIELD = {
    SHAKAI: "社会",
    CHIRI: "地理",
    REKISHI: "歴史",
    KOMIN: "公民"
}

const SUBJECTFIELD_ORDER_MAP: { [id: string] : number } = {
    "国語": 0,
    "地理": 1,
    "歴史": 2,
    "公民": 3,
    "数学": 4,
    "理科": 5,
    "英語": 6,
}

const SUBJECT_ID_MAP: { [value: string] : number } = {
      "all": 0,
      "kokugo": 1,
      "shakai": 2,
      "sugaku": 3,
      "rika": 4,
      "eigo": 5,
    }

const SUBJECTFIELD_ID_MAP: { [value: string] : number } = {
    "kokugo": 1,
    "chiri": 2,
    "rekishi": 3,
    "komin": 4,
    "sugaku": 5,
    "rika": 6,
    "eigo": 7,
}

const VALID_SUBJECT_NAME: Array<string> = [
    "kokugo",
    "shakai",
    "sugaku",
    "rika",
    "eigo",
]

export {
    SUBJECTS,
    SUBJECTFIELDS,
    SUBJECT_ALL,
    SUBJECT_MAP,
    SUBJECTFIELD_MAP,
    SUBJECTFIELD_SORT_MAP,
    SOCIETY_SUBJECT_FIELD,
    SUBJECTFIELD_ORDER_MAP,
    SUBJECT_ID_MAP,
    SUBJECTFIELD_ID_MAP,
    VALID_SUBJECT_NAME,
}
